(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];
  const menuButton = qs('[data-menu-toggle]');
  if (menuButton) menuButton.addEventListener('click', () => {
    const nav = qs('[data-main-nav]');
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
  });

  qsa('form.product-form').forEach(form => {
    form.addEventListener('submit', async event => {
      if (!form.querySelector('[name="id"]')) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-form-error]');
      const original = button?.textContent;
      if (error) { error.hidden = true; error.textContent = ''; }
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: {'Accept':'application/json'}, body: formData
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please check availability and try again.');
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{'Accept':'application/json'}});
        const cart = await cartResponse.json();
        qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count < 1; });
        const notice = qs('[data-cart-notice]');
        if (notice) {
          notice.hidden = false;
          notice.textContent = `${data.product_title || 'Item'} added to your cart.`;
        } else {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          return;
        }
        if (button) button.textContent = 'Added to cart';
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
        else window.alert(err.message);
      } finally {
        if (button) {
          window.setTimeout(() => { button.disabled = false; button.textContent = original || 'Add to cart'; }, 1200);
        }
      }
    });
  });

  qsa('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form?.querySelector('[name="id"]');
      if (idInput) idInput.value = select.value;
      const price = qs('[data-product-price]', form?.closest('[data-product-section]') || document);
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const button = form?.querySelector('[type="submit"]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      }
    });
  });

  qsa('[data-thumb]').forEach(button => button.addEventListener('click', () => {
    const target = qs('[data-gallery-main]');
    const img = qs('img', button);
    if (target && img) { target.src = img.dataset.full || img.src; target.alt = img.alt; }
  }));

  qsa('[data-cart-update]').forEach(button => button.addEventListener('click', () => {
    const form = button.closest('form');
    if (form) form.requestSubmit();
  }));
})();
